export enum ErrorType {
    InvalidInvitation = 'INVALID_INVITATION',
    InvalidQualifications = 'INVALID_INVITATION_QUALIFICATIONS',
    InvitationNotFound = 'INVITATION_NOT_FOUND',
    MinorSubject = 'MINOR',
    NotesError = 'NOTES_ERROR',
    UnknownError = 'UNKNOWN',
    InvalidZip = 'INVALID_ZIP'
}
